export type AssetURL = string

type VideoAssetType = {
  type: 'video'
  thumbnail: AssetURL
}

export type ImageAssetType = {
  type: 'image'
  source: AssetURL
  thumbnail: AssetURL
}

export const videoAsset = (thumbnail: string): VideoAssetType => ({
  type: 'video',
  thumbnail,
})

export const imageAsset = (
  source: string,
  thumbnail?: string,
): ImageAssetType => ({
  type: 'image',
  source,
  thumbnail: thumbnail || source,
})

export type Asset = VideoAssetType | ImageAssetType
